import React from "react";
import "./style.css";

const Separator = () => {
  return (
    <section className="separator">
      <div style={{ width: "100%", height: "10px", background: "#e9e9f0" }} />
    </section>
  );
};

export default Separator;



// WEBPACK FOOTER //
// ./src/components/Separator/index.js